import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { useIntl } from 'react-intl';

import * as actions from '../../../actions/index';
import './ResultsStep.scss';
import * as _actionsJourney3 from '../../../actions/journey3';
import * as _actionsJourney2 from '../../../actions/journey2';
import * as _actionsJourney1 from '../../../actions/journey1';
import * as _actionsBasket from '../../../actions/basket';
import * as _actionsFilters from '../../../actions/filters';

import ResultsList from './ResultsList';
import { parseToApiDate, prepareCoordinates } from '../../../utils/react';
import BottomNavigation from '../../../components/BottomNavigation';
import { cloneDeep, isEmpty } from 'lodash';
import { ResultFilter } from './ResultFilter';
import { Transition } from 'react-transition-group';
import ModalBackdrop from '../../../components/ModalBackdrop';
import Sidebar from '../../../components/Sidebar';
import { useMedia, useUpdateEffect } from 'react-use';
import { LoadingOverlay } from '../../../components/LoadingOverlay';
import * as _actionsSujet from '../../../actions/sujet';
import {
  SchemaAvailableProductGroupAttributes,
  SchemaPostFiltersRequestBody,
  SchemaPostProductRequestBody,
  SchemaProductGroupNode,
} from '@repo/legacy-commerce-api';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  actionsFilters: typeof _actionsFilters;
  actionsBasket: typeof _actionsBasket;
  actionsJourney2: typeof _actionsJourney2;
  actionsSujet: typeof _actionsSujet;
  availableAttributesJ2: SchemaAvailableProductGroupAttributes;
  postSelectResponseElements: SchemaProductGroupNode[] | null;
  userDataEC: PartiallyIntegratedUserDataEC;
  filterVisibility: any;
  mapView: boolean;
  setMapView: any;
  router: any;
  dispatch: any;
  loading: object;
}

const ResultsStep = ({
  actionsFilters,
  actionsJourney2,
  actionsBasket,
  actionsSujet,
  postSelectResponseElements,
  filterVisibility,
  mapView,
  setMapView,
  userDataEC: {
    productFilters,
    locations,
    format,
    target,
    attribute,
    startDate,
    duration,
    industry,
    commspace,
    isAgencyJourney,
    agencyInfoPanelVisibility,
    agencyData,
  },
  userDataEC,
  loading,
}: Props) => {
  const [checkedFilters, setCheckedFilters] = useState<any>([]);
  const [expandedFilters, setExpandedFilters] = useState<any>([]);
  const [isShowUnavailable, setIsShowUnavailable] = React.useState(false);
  const [sort, setSort] = React.useState({ name: 0, price: 0 });
  const [currentSort, setCurrentSort] = React.useState('price');
  const [slotsLoading, setSlotsLoading] = React.useState(true);
  const [filtersLoading, setFiltersLoading] = React.useState(true);
  const isFilterChecked = (filter: any) => checkedFilters.includes(filter);
  const isMobile = useMedia('(max-width: 768px)');
  const [isFilterOpen, setIsFilterOpen] = React.useState<boolean>(false);
  const filterModalref = useRef(null);
  const [productsList, setProductsList] = useState<any>([]);
  const intl = useIntl();

  console.log('userDataEC', userDataEC);

  const handleClickOutside = (event) => {
    if (
      filterModalref.current &&
      !filterModalref.current.contains(event.target) &&
      !event.target.className.includes('results-filter')
    ) {
      setIsFilterOpen(false);
    }
  };

  useEffect(() => {
    setFiltersLoading(true);
    actionsFilters
      .updateProductFilters(generateCriteria())
      .then((res) => {
        if (res && res.length > 0) {
          setExpandedFilters([res[0].selectfield]);
          setCheckedFilters([...format, ...target, ...attribute, ...commspace]);
          setFiltersLoading(false);
        }
      })
      .catch(() => {
        setFiltersLoading(false);
      });

    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  useUpdateEffect(() => {
    if (userDataEC.isAgencyJourney && userDataEC?.industry && userDataEC?.agencyData?.customer?.branche) {
      getPostSelect();
    }
  }, [userDataEC.industry]);

  useEffect(() => {
    setProductsList(postSelectResponseElements || []);
    applyFilters();
  }, [postSelectResponseElements]);

  const selectFilter = (code: number, filterField: string) => {
    let newFilters: any[];
    let newSelectFieldValues = [...userDataEC[filterField]];
    if (isFilterChecked(code)) {
      newFilters = checkedFilters.filter((f: any) => f !== code);
      newSelectFieldValues = newSelectFieldValues.filter((f: any) => f !== code);
    } else {
      newFilters = [...checkedFilters, code];
      newSelectFieldValues.push(code);
    }
    setCheckedFilters(newFilters);
    actionsFilters.setResultsFilters({ [filterField]: newSelectFieldValues });
    if (filterField === 'format') {
      applyFilters(newSelectFieldValues, target, attribute, commspace);
    } else if (filterField === 'target') {
      applyFilters(format, newSelectFieldValues, attribute, commspace);
    } else if (filterField === 'attribute') {
      applyFilters(format, target, newSelectFieldValues, commspace);
    } else if (filterField === 'commspace') {
      applyFilters(format, target, attribute, newSelectFieldValues);
    }
  };

  const clearFilters = () => {
    let filterFields = ['format', 'target', 'attribute', 'commspace'];
    setCheckedFilters([]);
    setExpandedFilters([]);
    filterFields.map((field) => actionsFilters.setResultsFilters({ [field]: [] }));
    applyFilters([], [], [], []);
  };

  const generateCriteria = (): SchemaPostFiltersRequestBody => {
    const newLocations = { ...locations };
    let individualProductsId = '';

    const individualProducts =
      locations &&
      Object.values(locations)
        .filter(({ address }: any) => address && address.toLowerCase().includes('id:'))
        .map(({ product, address }: any) => {
          if (address) {
            individualProductsId += `-${address}`;
          }
          return product.producturn;
        });

    if (individualProductsId) {
      for (const locationsKey in newLocations) {
        const address = newLocations[locationsKey] ? newLocations[locationsKey].address : null;

        if (individualProductsId.includes(address)) {
          delete newLocations[locationsKey];
        }
      }
    }

    let searchurn = [];

    for (const locationKey of Object.keys(locations)) {
      const location = locations[locationKey];
      if (location.context !== 'address' && location.product) {
        searchurn.push(location.product.id);
        delete newLocations[locationKey];
      }

      if (location.context === 'postal_code') {
        const splittedAddress = location.address.split(' ');
        const zip = splittedAddress[0];
        searchurn.push(`google:zip:${zip}:${location.address}:${location.lngLtd.lng}:${location.lngLtd.lat}`);
        delete newLocations[locationKey];
      }
    }

    return {
      availability: {
        startdate: parseToApiDate(startDate),
        duration: duration,
      },
      individualproducts: individualProducts || [],
      showNotAvailable: isShowUnavailable,
      coordinate: prepareCoordinates(newLocations),
      // @ts-expect-error OpenAPI spec mimatch: assigning empty array fallback
      industry: industry || [],
      searchurn: searchurn,
    };
  };

  const generatePostPayload = (mapPotentialCoordinates?): SchemaPostProductRequestBody => {
    const result = {
      sort: [{ column: currentSort, direction: sort[currentSort] }],
      group: ['producttype', 'city', 'format'],
      criteria: generateCriteria(),
    };

    if (mapPotentialCoordinates) {
      result['mapview'] = mapPotentialCoordinates;
    }
    console.log('generatePostPayload', userDataEC);
    if (userDataEC.basketInfo) {
      result['basket'] = userDataEC.basketInfo.basket;
      result['basketreference'] = userDataEC.basketInfo.basketreference;
    }

    // @ts-expect-error sort types don't match, validate:
    return result;
  };

  const getPostSelect = (mapPotentialCoordinates?) => {
    setIsFilterOpen(false);
    setSlotsLoading(true);

    actionsJourney2.postSelect(generatePostPayload(mapPotentialCoordinates));
  };

  const checkMatchByField = (
    field: string,
    tag: string,
    product: {
      [x: string]: any;
      tags: { [x: string]: any };
    },
    selectedFilterValues: any[],
  ) => {
    let isProductMatch = true;

    let tagsIntersection = [];

    if (product.tags[tag]) {
      tagsIntersection = selectedFilterValues.filter((p: any) => product.tags[tag].includes(p));
      if (tagsIntersection.length == 0) {
        isProductMatch = false;
      }
    }

    return isProductMatch;
  };

  const applyFilters = (_format = format, _target = target, _attribute = attribute, _commspace = commspace) => {
    setSlotsLoading(true);

    let newProductsList = [];

    if (!postSelectResponseElements) {
      return;
    }

    for (const productTypeGroup of postSelectResponseElements) {
      const newProductTypeGroup = cloneDeep(productTypeGroup);
      let productsCounter = 0;

      if (newProductTypeGroup.subgroup) {
        for (const level2group of newProductTypeGroup.subgroup.elements) {
          if (level2group.subgroup) {
            let subgroupProductsCounter = 0;

            for (const level3group of level2group.subgroup.elements) {
              // @ts-expect-error products does not exist in this format on the OpenAPI spec, resolve later:
              if (level3group.products) {
                let newProducts = [];
                let deepestProductsCounter = 0;

                // @ts-expect-error products does not exist in this format on the OpenAPI spec, resolve later:
                for (const product of level3group.products) {
                  let isProductMatch = true;

                  const isCheckFormats = _format.length != 0;
                  let isFormatMatched = true;

                  const isCheckTargets = _target.length != 0;
                  let isTargetMatched = true;

                  const isCheckAttributes = _attribute.length != 0;
                  let isAttributeMatched = true;

                  const isCheckCommspace = _commspace.length != 0;
                  let isCommspaceMatched = true;

                  if (isCheckFormats) {
                    isFormatMatched = _format.includes(product.formatcode);
                  }

                  if (isCheckTargets) {
                    isTargetMatched = checkMatchByField('target', 'target', product, _target);
                  }

                  if (isCheckAttributes) {
                    let allTagsInProduct = false;
                    let allFieldValuesInProduct = false;

                    if (product.tags.attribute) {
                      allTagsInProduct = _attribute.every((val: string) => product.tags.attribute.includes(val));
                    }

                    if (product.attribute) {
                      // @ts-expect-error type mismatch coming from string[] to boolean
                      allFieldValuesInProduct = _attribute.filter((p: string) => product.attribute.includes(p));
                    } else {
                      allFieldValuesInProduct = true;
                    }

                    if (!allTagsInProduct || !allFieldValuesInProduct) {
                      isAttributeMatched = false;
                    }
                  }

                  if (isCheckCommspace) {
                    if (product.commspace) {
                      isCommspaceMatched = checkMatchByField('commspace', 'commspace', product, _commspace);
                    } else {
                      isCommspaceMatched = checkMatchByField('communicationspaces', 'commspace', product, _commspace);
                    }
                  }

                  isProductMatch = isFormatMatched && isTargetMatched && isAttributeMatched && isCommspaceMatched;

                  if (isProductMatch) {
                    newProducts.push(product);
                    productsCounter++;
                    subgroupProductsCounter++;
                    deepestProductsCounter++;
                  }
                }

                // @ts-expect-error products does not exist in this format on the OpenAPI spec, resolve later:
                level3group.products = newProducts;
                level3group.count = deepestProductsCounter;
              }
            }

            level2group.count = subgroupProductsCounter;
          }
        }
      }
      newProductTypeGroup.count = productsCounter;
      newProductsList.push(newProductTypeGroup);
    }
    setProductsList(newProductsList);

    setTimeout(() => {
      setSlotsLoading(false);
    }, 300);
  };

  return (
    <div className='step6'>
      {(filtersLoading || loading['productsPost']) && (
        <LoadingOverlay
          headerText={intl.formatMessage({
            id: 'ec.journey02.step06.spinnerHeaderText',
            defaultMessage: 'Bitte haben Sie einen Moment Geduld.',
          })}
          // text={intl.formatMessage({
          //     id: 'ec.journey02.step06.spinnerTextReservingBasket',
          //     defaultMessage: 'Wir suchen für Sie die passenden Flächen gemäss Ihren Kriterien.',
          // })}
        />
      )}
      {isMobile && (
        <Transition in={isFilterOpen} timeout={50}>
          {(state) => (
            <ModalBackdrop duration={250} state={state}>
              <Sidebar duration={250} state={state}>
                {isFilterOpen && (
                  <div className='results-filter h-100 overflow-hidden' ref={filterModalref}>
                    <ResultFilter
                      checkedFilters={checkedFilters}
                      selectFilter={selectFilter}
                      clearFilters={clearFilters}
                      setExpandedFilters={setExpandedFilters}
                      expandedFilters={expandedFilters}
                      setIsFilterOpen={setIsFilterOpen}
                      productFilters={productFilters}
                      filterVisibility={filterVisibility}
                      setFilterVisibility={(value) => {
                        actionsFilters.setResultsFiltersVisibility(value);
                      }}
                      userDataEC={userDataEC}
                    />
                  </div>
                )}
              </Sidebar>
            </ModalBackdrop>
          )}
        </Transition>
      )}

      {!isMobile && filterVisibility && (
        <div className='w-22'>
          <ResultFilter
            checkedFilters={checkedFilters}
            selectFilter={selectFilter}
            clearFilters={clearFilters}
            setExpandedFilters={setExpandedFilters}
            expandedFilters={expandedFilters}
            setIsFilterOpen={setIsFilterOpen}
            productFilters={productFilters}
            filterVisibility={filterVisibility}
            setFilterVisibility={(value) => {
              actionsFilters.setResultsFiltersVisibility(value);
            }}
            userDataEC={userDataEC}
          />
        </div>
      )}
      <div className={isMobile ? 'w-100' : filterVisibility ? 'w-78' : 'w-100'}>
        <ResultsList
          isShowUnavailable={isShowUnavailable}
          setIsShowUnavailable={setIsShowUnavailable}
          generatePostPayload={generatePostPayload}
          setCurrentSort={setCurrentSort}
          sort={sort}
          setSort={setSort}
          mapView={mapView}
          setMapView={setMapView}
          currentSort={currentSort}
          slotsLoading={slotsLoading}
          isMobile={isMobile}
          setIsFilterOpen={setIsFilterOpen}
          setSlotsLoading={setSlotsLoading}
          getPostSelect={getPostSelect}
          products={productsList}
        />
      </div>
      <BottomNavigation
        isDisabled={isEmpty(userDataEC.basketProducts.products)}
        nextCallback={() => {
          actionsBasket.openBasket();
        }}
        isAgencyJourney={isAgencyJourney}
        changeAgencyInfoPanelVisibility={(value) => {
          actionsSujet.setAgencyInfoPanelVisibility(value);
        }}
        agencyInfoPanelVisibility={agencyInfoPanelVisibility}
        agencyData={agencyData}
      />
    </div>
  );
};

function mapStateToProps(state: any, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsJourney1: bindActionCreators(_actionsJourney1 as any, dispatch),
    actionsJourney2: bindActionCreators(_actionsJourney2 as any, dispatch),
    actionsJourney3: bindActionCreators(_actionsJourney3 as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    actionsFilters: bindActionCreators(_actionsFilters as any, dispatch),
    actionsSujet: bindActionCreators(_actionsSujet as any, dispatch),
    dispatch: dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResultsStep));
